<template>
    <footer class="page-footer d-none d-sm-none d-md-none d-lg-block">
        <div id="carousel-1autorent" class="carousel-1a slide carousel-fade">
            <ol class="carousel-indicators mb-0">
                <li v-for="(slide, i) in slides" :class="{active: active_slide === i}" @click="active_slide = i" :key="i"></li>
            </ol>
            <div class="carousel-inner" role="listbox">
                <div class="carousel-item" v-for="(slide, i) in slides" :class="{active: active_slide === i}" :key="i">
                    <router-link :to="{name: 'specials'}">
                        <div class="view">
                            <div class="justify-content-center align-items-center">
                                <div class="container-fluid align-self-center text-center white-text mx-5 my-5 wow fadeIn" style="margin: 24px!important;">
                                    <template v-if="slide.dbname">
                                        <img :src="`${envUrl}/offers/${slide.dbname}`" height="auto" class="img-fluid rounded" style="margin: 0 auto;"/>
                                    </template>
                                    <template v-else>
                                        <h1 class="display-4">{{ slide.name[locale] }}</h1>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <a class="carousel-control-prev" role="button" data-slide="prev" @click="slidePrev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">{{ $t('Previous') }}</span>
            </a>
            <a class="carousel-control-next" role="button" data-slide="next" @click="slideNext">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">{{ $t('Next') }}</span>
            </a>
        </div>
        <app-cookies/>
    </footer>
</template>

<script>

import AppCookies from './Cookies';
import PublicSpecialOfferService from '@services/publicSpecialOffer.service';
import {mapGetters} from 'vuex';

export default {
    name: 'AppFooter',
    data() {
        return {
            active_slide: 0,
            slides: []
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        slidePrev() {
            if (this.active_slide === 0) {
                this.active_slide = this.slides.length;
            } else {
                this.active_slide--;
            }
        },
        slideNext() {
            if (this.active_slide + 1 === this.slides.length) {
                this.active_slide = 0;
            } else {
                this.active_slide++;
            }
        },
        slider() {
            this.slideNext();
            let to;
            clearTimeout(to);
            to = setTimeout(() => {
                this.slider();
            }, 5000);
        },
        getSpecialOffers() {
            PublicSpecialOfferService.getSpecialOffers().then(res => {
                this.slides = res.filter(o => {
                    return o.dbname !== null;
                });
                this.slider();
            });
        }
    },
    components: {
        AppCookies
    },
    created() {
        this.getSpecialOffers();
    }
};
</script>
